import dynamic from 'next/dynamic';
import { CardHorizontalFeatureProps } from './CardHorizontalFeature.types';

export const CardHorizontalFeature = dynamic<CardHorizontalFeatureProps>(() =>
  import('./CardHorizontalFeature').then(module => module.CardHorizontalFeature)
);
